import { useAction, useAtom } from "@reatom/npm-react";
import { ProductDetailResponseDto } from "definitions/product-storage";
import { useEffect } from "react";
import { getActiveLimiterRequest, getMeRequest } from "src/store/fetchers";

import { ACCESS_COST } from "../ResponsiveProductDetailWidget.constant";
import { getProductDetailFromStorage } from "../store/fetchers/getProductDetailWithPrice";

interface UseProductDetailReturn {
  product: ProductDetailResponseDto | null;
  isLoading: boolean;
  hasMoney: boolean;
  hasSubscribe: boolean;
}

export const useProductDetail = (spuId: number): UseProductDetailReturn => {
  const [userInfo] = useAtom(getMeRequest.dataAtom);
  const [activeLimiter] = useAtom(getActiveLimiterRequest.dataAtom);

  const [product, setProduct] = useAtom(getProductDetailFromStorage.dataAtom);
  const [isLoading] = useAtom(getProductDetailFromStorage.isLoadingAtom);
  const loadProductDetail = useAction(getProductDetailFromStorage);

  const hasMoney = (userInfo?.credit ?? 0) >= ACCESS_COST;
  const hasSubscribe = (activeLimiter?.length ?? 0) > 0;

  useEffect(() => {
    if (!spuId || (!hasMoney && !hasSubscribe)) {
      return;
    }

    loadProductDetail(spuId);

    return () => {
      setProduct(null);
    };
  }, [hasMoney, hasSubscribe, loadProductDetail, setProduct, spuId]);

  return {
    product,
    isLoading,
    hasMoney,
    hasSubscribe,
  };
};
